(ns ductile.ui.mobile
  (:require ["react" :refer [useContext]]
            ["signature_pad" :as signature-pad]
            [applied-science.js-interop :as j]
            [clojure.string :as str]
            [ductile.time.js-types :as time]
            [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.locale :as locale :refer [tr]]
            [ductile.ui.scene :as scene]
            [ductile.ui.util :as ui.util]
            [nextjournal.clerk.render.hooks :as hooks]
            [reagent.core :as r])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]))

(defn notch []
  [:div {:class "w-[219px] h-[23px] bg-center bg-no-repeat"}
   [:svg.mx-auto {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 219 31" :height 23}
    [:path {:fill "#000" :d "M0 1V0h219v1a5 5 0 0 0-5 5v3c0 12.15-9.85 22-22 22H27C14.85 31 5 21.15 5 9V6a5 5 0 0 0-5-5z" :fill-rule "evenodd"}]]])

(defn strip []
  [:div {:class "w-[120px] h-1 bg-[#999] rounded-full"}])

(def screen-radius "rounded-[38px] ")
(def screen-radius-t "rounded-t-[38px] ")
(def screen-radius-b "rounded-b-[38px] ")

(defn iphone-portrait [& content]
  [:div {:class "rounded-[54px] w-[320px] overflow-hidden box-content p-3 bg-black relative"
         :style {"--safe-inset-top" "44px"}}
   (into [:div {:class (str "w-[320px] h-[680px] overflow-hidden bg-white " screen-radius)}] content)
   [:div {:class "absolute left-1/2 -translate-x-1/2 top-[13px] pointer-events-none z-50"}
    [notch]]
   [:div {:class "absolute left-1/2 -translate-x-1/2 bottom-[27px] pointer-events-none z-50"}
    [strip]]])

(def pb-safe "pb-[34px] ")
(def bg-bars "bg-[rgba(247,247,248,.8)] ")
(def translucent "backdrop-blur-[20px] backdrop-saturate-[180%] ")
(def hairline-t "before:content-[''] before:absolute before:bg-black/20 before:z-[10] before:left-0 before:top-0 before:w-full before:h-[1px] before:scale-y-50 ")
(def hairline-b "after:content-[''] after:absolute after:bg-black/20 after:z-[10] after:left-0 after:bottom-0 after:w-full after:h-[1px] after:scale-y-50 ")
(def last-child-hairline-b "last:after:content-[''] last:after:absolute last:after:bg-black/20 last:after:z-[10] last:after:left-0 last:after:bottom-0 last:after:w-full last:after:h-[1px] last:after:scale-y-50 ")
(def text-primary "text-indigo-600 ")
(def bg-primary "bg-indigo-600 ")
(def border-primary "border-indigo-600 ")
(def bg-primary-active "active:bg-indigo-700 ")
(def bg-primary-hover "enabled:hover:bg-indigo-700 ")
(def bg-destructive "bg-red-600 ")
(def border-destructive "border-red-600 ")
(def bg-destructive-active "active:bg-red-700 ")
(def bg-destructive-hover "enabled:hover:bg-red-700 ")
(def bg-page "bg-[#efeff4] ")

(defn toolbar [& content]
  (let [history? (useContext ui/history-context)]
    [:div.w-full.z-20.left-0.bottom-0 {:class (if history? "sticky translate-y-[65px]" "fixed")}
     [:div.absolute.w-full.h-full.left-0.top-0
      {:class (str hairline-t bg-bars translucent)}]
     (into [:div.flex.relative.justify-between.items-center.w-full.px-2.py-2] content)]))

(defn scroll-content [& content]
  (let [[opts content] (ui/opts+content content)
        history? (useContext ui/history-context)]
    [:div.w-full.relative
     {:class (cond
               history? ["h-[700px]"]
               (= :simulate-device (:layout/variant opts)) ["h-[680px]" "rounded-[38px]"]
               :else ["h-screen"])}
     (into [:div.h-full.w-full.left-0.top-0.absolute.overflow-auto.overscroll-contain.mobile-scroll-content-legacy
            {:class bg-page}] content)]))

(def chevron-left
  [:svg {:xmlns "http://www.w3.org/2000/svg" :width "12" :height "20" :viewBox "0 0 12 20" :fill "currentcolor"}
   [:path {:d "M0.18261596,9.4221638 C0.21783626,9.37068075 0.25835058,9.32165682 0.30416276,9.27584463 L9.1425872,0.4374202 C9.7256776,-0.14567018 10.6691555,-0.1475686 11.2590259,0.44230183 C11.8448123,1.02808827 11.8502479,1.97240019 11.2639075,2.55874056 L3.82594417,9.9967039 L11.2578297,17.4285894 C11.8409201,18.0116798 11.8428185,18.9551577 11.252948,19.5450281 C10.6671616,20.1308146 9.7228497,20.1362501 9.13650932,19.5499097 L0.2980849,10.7114853 C-0.0545897,10.3588107 -0.0959125,9.8144953 0.18261596,9.4221638 Z"}]])

(def chevron-right
  [:svg {:xmlns "http://www.w3.org/2000/svg" :width "12" :height "20" :viewBox "0 0 12 20" :fill "currentcolor"}
   [:path {:d "M0.18261596,9.4221638 C0.21783626,9.37068075 0.25835058,9.32165682 0.30416276,9.27584463 L9.1425872,0.4374202 C9.7256776,-0.14567018 10.6691555,-0.1475686 11.2590259,0.44230183 C11.8448123,1.02808827 11.8502479,1.97240019 11.2639075,2.55874056 L3.82594417,9.9967039 L11.2578297,17.4285894 C11.8409201,18.0116798 11.8428185,18.9551577 11.252948,19.5450281 C10.6671616,20.1308146 9.7228497,20.1362501 9.13650932,19.5499097 L0.2980849,10.7114853 C-0.0545897,10.3588107 -0.0959125,9.8144953 0.18261596,9.4221638 Z"}]])

(def truck
  [:svg {:xmlns "http://www.w3.org/2000/svg" :width "30" :height "30" :fill "none" :viewBox "0 0 24 24" :stroke "currentColor" :stroke-width "2"}
   [:path {:d "M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"}]
   [:path {:stroke-linecap "round" :stroke-linejoin "round" :d "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"}]])

(defn back-link [{:keys [title route on-click confirm]}]
  [:a.inline-flex.space-x-1.justify-center.items-center.cursor-pointer.select-none.active:opacity-30.duration-300.active:duration-0.h-full.max-h-12
   (ui.util/dissoc-blank-vals
    {:data-testid "back-button"
     :class text-primary
     :href route
     :on-click (if confirm
                 (fn [e]
                   (when-not (js/window.confirm confirm)
                     (.stopPropagation e)
                     (.preventDefault e)))
                 on-click)})
   (if title
     [:<>
      [:span chevron-left]
      [:span title]]
     [ui/icon :arrow-left])])

(defn right-button [{:keys [icon title route]}]
  [:div.flex.justify-center.items-center.h-full.ml-2.transform.transform-gpu {:class "z-[20]"}
   [:a.text-primary.inline-flex.space-x-1.justify-center.items-center.cursor-pointer.select-none.active:opacity-30.duration-300.active:duration-0.h-full.max-h-12
    {:class text-primary
     :href route}
    icon
    title]])

(defn navbar [{:as opts :keys [title subtitle back right right-item]}]
  [:div.w-full.top-0.sticky.navbar {:class "z-[18]"}
   [:div.absolute.w-full.h-full.left-0.top-0
    {:class (str bg-bars translucent hairline-b (when (= :simulate-device (:layout/variant opts)) "rounded-t-[38px]"))}]
   [ui/env-bar]
   [:div.flex.relative.items-center.w-full.px-2.h-11.justify-between
    (when back
      [:div.h-full {:class "z-[20]"} back])
    [:div.text-black.dark:text-white.whitespace-nowrap.leading-tight.font-semibold.absolute.transform-gpu.text-center.w-full.max-w-full
     {:class [(when back  "pl-10") (when right "pr-11") (when right-item "pr-11") "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"]
      :style {:height "calc(100% - 2px)"}}
     [:div.overflow-auto.scroll-shadows-x-mobile.flex.flex-col.h-full.justify-center {:style {:scrollbar-width :none} :class "z-[19]"}
      title
      (when subtitle
        [:div.font-normal.leading-none.opacity-50 {:class "text-[0.7rem]"} subtitle])]]
    (when right
      [right-button right])
    (when right-item
      [:div.h-full {:class "z-[20]"} right-item])]])

(def table-disclose
  [:svg.opacity-20.shrink-0.ml-3 {:xmlns "http://www.w3.org/2000/svg" :width "8" :height "14" :viewBox "0 0 12 20" :fill "currentcolor"}
   [:path {:d "M11.518406,10.5648622 C11.4831857,10.6163453 11.4426714,10.6653692 11.3968592,10.7111814 L2.5584348,19.5496058 C1.9753444,20.1326962 1.03186648,20.1345946 0.44199608,19.5447242 C-0.14379032,18.9589377 -0.14922592,18.0146258 0.43711448,17.4282854 L7.87507783,9.9903221 L0.4431923,2.5584366 C-0.1398981,1.9753462 -0.1417965,1.0318683 0.448074,0.4419979 C1.0338604,-0.1437886 1.9781723,-0.1492241 2.56451268,0.4371163 L11.4029371,9.2755407 C11.7556117,9.6282153 11.7969345,10.1725307 11.518406,10.5648622 Z"}]])

(defn framed-icon
  ([name]
   [framed-icon "bg-indigo-600" name])
  ([bg-color-class name]
   [:div.rounded-md.w-6.h-6.flex.items-center.justify-center.text-white
    {:class bg-color-class}
    [ui/icon {:size 16} name]]))

(defn list-item [{:keys [class on-click on-mouse-enter style title icon route right left-label description subtitle as data-testid]}]
  [:li.bg-white.focus-visible:bg-indigo-50.focus-visible:outline-none
   (cond-> {:class last-child-hairline-b
            :tab-index 0
            :on-key-down (when on-click (fn [^js e]
                                          (when (contains? #{"Enter" "Space"} (.-code e))
                                            (.preventDefault e)
                                            (.stopPropagation e)
                                            (on-click e))))}
     on-click (assoc :on-click (fn [e]
                                 (on-click e)
                                 (.preventDefault e)
                                 (.stopPropagation e)))
     on-mouse-enter (assoc :on-mouse-enter on-mouse-enter)
     style (assoc :style style))
   [(or as :a)
    {:href route
     :data-testid data-testid
     :class (ui/class-vec "pl-4 flex items-center w-full text-left" class)}
    (when icon
      [:div.mr-4.shrink-0.py-2 icon])
    [:div.pr-4.w-full.relative.py-2.5.flex.flex-col.justify-center
     {:class (str "min-h-[44px] " hairline-b)}
     [:div.flex.justify-between.items-center
      {:class "text-[14px]"}
      [:div.shrink.leading-tight.w-full
       (if left-label
         [:div.flex.items-center.gap-3
          [:div.text-slate-500 left-label]
          title]
         title)
       (when subtitle
         [:div.text-xs.mt-1 subtitle])
       (when description
         [:div.text-black.text-opacity-50.line-clamp-2.mt-1
          {:class "text-[0.7rem]"}
          description])]
      right]]]])

(defn list-item-disclose [opts]
  [list-item (-> opts
                 (assoc :right table-disclose)
                 (update :class ui/class-vec "duration-300 active:duration-0 cursor-pointer select-none active:bg-black active:bg-opacity-10"))])

(defn input-text-class [{:keys [right]}]
  ["pl-4" (when-not right "pr-4") "py-2.5" "block" "text-base" "appearance-none" "w-full" "focus:outline-none" "bg-transparent" "h-11" "placeholder-black" "placeholder-opacity-30" "disabled:opacity-50" "shadow-none" "focus:shadow-none" "border-0" "bg-transparent" "hover:bg-transparent" "text-black"])

(defn list-item-input [{:as opts :keys [input icon label description error]}]
  [:li {:class (if (:disabled? input) "bg-gray-50" "bg-white")
        :on-click (fn [^js e] (.. e -currentTarget (querySelector "input,textarea") (focus)))}
   [:div.flex.items-center.duration-300.active:duration-0.cursor-pointer.select-none.active:bg-black.active:bg-opacity-10
    [:div.w-full.relative
     {:class (str "min-h-[44px] " hairline-b)}
     [:div.w-full
      {:class "text-[17px]"}
      (when label
        [:div.text-xs.pt-2.5.px-4 {:class (when error ["text-red-600" "font-bold"])} label])
      [:div.flex.gap-2
       (when icon
         (if (keyword? icon)
           [:div.shrink-0.items-center.justify-center.flex.ml-4
            {:class "-mr-[0.6rem]"}
            [ui/icon {:size 24} icon]]
           [:div.shrink-0 icon]))
       [ui/input (merge input {:variant :mobile
                               :size 4
                               :right (when-let [right (:right input)]
                                        (if (vector? right)
                                          right
                                          (into [:div.text-base.pr-2.text-slate-600] (:right input))))})]]
      (when error
        [:div.text-red-600.pb-2.5.px-4
         {:class "text-[0.725rem]" :data-testid (str (:data-testid input) "=error")}
         error])
      (when description
        [:div.text-black.text-opacity-50.line-clamp-2
         {:class "text-[0.725rem]"}
         description])]]]])

(defn list-item-toggle [{:keys [input label]}]
  [:li.bg-white
   [:div.pl-4.flex.items-center.duration-300.active:duration-0.cursor-pointer.select-none.active:bg-black.active:bg-opacity-10
    [:div.mr-4.shrink-0.py-2
     [:div.flex.justify-between.items-center
      [:div.shrink label]]]
    [:div.pr-4.w-full.relative.py-2.5.flex.flex-col.items-end
     {:class (str "min-h-[44px] " hairline-b)}
     [:label.relative.cursor-pointer.select-none.inline-block.align-middle.relative.duration-300.rounded-full.h-8.-my-1
      {:style {:width "3.25rem" :padding "0.125rem"}
       :class (str (if (:checked input) bg-primary "bg-black bg-opacity-10") " "
                   (when (:disabled input) "opacity-50 pointer-events-none"))}
      [:input.hidden (merge {:type "checkbox"}
                            (dissoc input :data-testid))]
      [:span.w-full.h-full.bg-white.rounded-full.block.duration-300.transform
       {:class (when (:checked input) "scale-0")}]
      [:span.rounded-full.absolute.duration-300.transform.w-7.h-7.bg-white
       {:data-testid (get input :data-testid "item-toggle")
        :style {:box-shadow "0 2px 4px rgba(0,0,0,.3)"}
        :class (str "left-[.125rem] top-[.125rem] " (when (:checked input) "translate-x-5"))}]]]]])

(defn list-item-checkbox [{:keys [icon input label description class]}]
  [:li.bg-white.focus-visible:bg-indigo-100.focus-visible:outline-none
   {:class (ui/class-vec class last-child-hairline-b)
    :tab-index 0
    :on-key-down (fn [^js e]
                   (when (contains? #{"Enter" "Space"} (.-code e))
                     (.preventDefault e)
                     ((:on-change input))))}
   [:label.pl-4.flex.items-center.duration-300.active:duration-0.cursor-pointer.select-none.active:bg-black.active:bg-opacity-10
    {:data-testid (:data-testid input)}
    [:div.mr-4.shrink-0.py-2
     {:class (when (:disabled input) "opacity-50 pointer-events-none")}
     [:div.cursor-pointer.inline-block.align-middle.relative
      [:input.hidden (merge {:type "checkbox"} (dissoc input :data-testid))]
      (if (:checked input)
        (or icon
            [:i.flex.items-center.justify-center.text-white.dark:text-black.rounded-md.border
             {:class (str "w-[22px] h-[22px] " bg-primary border-primary)}
             [:svg.opacity-100 {:xmlns "http://www.w3.org/2000/svg" :width "20" :height "20" :viewBox "0 0 20 20" :fill "currentcolor"}
              [:path {:fill "currentColor" :fill-rule "evenodd" :d "M10.6461792,0.119820016 C11.0022676,0.346673312 11.1070333,0.819240884 10.88018,1.17532923 L5.59004012,9.47918548 C5.44456028,9.70754308 5.19802823,9.83254199 4.94596825,9.83309245 C4.59813173,9.83364386 4.39457446,9.67360825 4.28105047,9.53831563 L1.17887189,5.84128316 C0.907480501,5.5178515 0.949667479,5.03565214 1.27309914,4.76426075 C1.59653081,4.49286936 2.07873017,4.53505633 2.35012156,4.858488 L4.8346263,7.81909046 L9.59067001,0.353820775 C9.81752331,-0.00226757161 10.2900909,-0.10703328 10.6461792,0.119820016 Z" :transform "translate(4 5.483)"}]]])
        [:i.flex.items-center.justify-center.text-white.dark:text-black.rounded-md.border.border-black.border-opacity-30.dark:border-white.dark:border-opacity-30
         {:class "w-[22px] h-[22px] "}])]]
    [:div.pr-4.w-full.relative.py-2.5.flex.flex-col.justify-center
     {:class (str "min-h-[44px] " hairline-b)}
     [:div.flex.justify-between.items-center
      [:div.flex-auto (when (:disabled input)
                        {:class "opacity-50"})
       label
       (when description
         [:div.text-slate-500
          {:class ["text-[0.725rem]"]
           :data-testid (str (:data-testid input) "=description")}
          description])]]]]])

(defn list-item-checkbox-stepper [{:keys [label input]}]
  (let [{:keys [value on-change]} input]
    [list-item-checkbox
     {:label [:div.w-full.flex.space-between.items-center.relative.flex-wrap
              [:div.flex-auto label]
              [ui/stepper input]]
      :input {:checked (pos? value)
              :on-change #(on-change (if (.. % -target -checked) 1 nil))
              :data-testid (:data-testid input)}}]))

(defn add-image-button [{:as attrs :keys [label]}]
  [:div.flex.items-center.gap-3.cursor-pointer.group
   (dissoc attrs :label)
   [:div.rounded-md.border-2.bg-white.flex.items-center.justify-center.text-indigo-600.border-indigo-600.group-hover:border-indigo-700.group-hover:text-indigo-700.flex-shrink-0
    {:class "w-[40px] h-[40px]"}
    [ui/icon {:size 20} :camera]]
   [:div.text-indigo-600.group-hover:text-indigo-700.text-sm label]])

(defn modal [{:keys [on-close class]} & content]
  [ui/alert {:open? true
             :on-close on-close}
   (into [ui/alert-content {:full? true
                            :class (or class "max-h-[80vh] w-[320px] md:w-[500px]")}
          [ui/modal-close {:on-click on-close}]]
         content)])

(defn image-modal [{:as img :keys [label url on-close]}]
  [modal img
   [:div.bg-white.rounded-lg.shadow-lg
    [:div.flex.justify-between.items-center.py-4.px-6.border-b
     [:h4.mt-0.text-base.font-bold (or label (tr "Image Detail"))]]
    [:div.bg-slate-50.py-4.px-6
     [:img {:src url}]]]])

(defn image-tile [{:as img :keys [label remove-fn url size]}]
  (r/with-let [!modal-open? (r/atom false)]
    [:<>
     [:div.relative
      [:div.rounded-md.border.border-slate-400.hover:border-indigo-600.shadow.bg-cover.cursor-pointer
       {:data-testid "uploaded-photo"
        :style {:background-image (str "url(" url ")") :background-color "#eee" :width (or size 100) :height (or size 100)}
        :on-click #(reset! !modal-open? true)}]
      (when label
        [:div {:class "w-[40px] text-[10px]"} label])
      (when remove-fn
        [:div.bg-indigo-600.border-2.border-white.rounded-full.text-white.flex.items-center.justify-center.absolute.cursor-pointer.hover:bg-indigo-700
         {:class "w-[20px] h-[20px] -top-[7px] -right-[7px]"
          :data-testid "remove-photo"
          :on-click remove-fn}
         [ui/icon {:size 10} :x]])]
     (when @!modal-open?
       [image-modal (assoc img :on-close #(reset! !modal-open? false))])]))

(defn capture-image [{:keys [on-capture] :or {on-capture #()}} & content]
  (let [!el (hooks/use-ref nil)]
    (into
     [:div
      {:on-click #(when-let [el @!el] (.click el))}
      [:input.hidden
       {:type :file
        :accept "image/*"
        :capture :environment
        :ref !el
        :on-change (fn [_event]
                     (let [file (first (.-files @!el))
                           reader (js/FileReader.)]
                       (j/assoc! reader :onloadend (fn []
                                                     (let [base64-image (.-result reader)]
                                                       (on-capture base64-image))))
                       (when file
                         (.readAsDataURL reader file))))}]]
     content)))

(defn radio-button [{:as button :keys [input label label-view error description class on-mouse-enter]}]
  [:li.mt-2.first:mt-0.mx-3.border.group.rounded-md.border.bg-white.overflow-hidden.focus-visible:bg-indigo-100
   {:class (ui/class-vec class (if (:checked input)
                                 ["border-indigo-600" "outline" "outline-indigo-600"]
                                 ["border-gray-300" "focus-visible:outline-none"]))
    :tab-index 0
    :on-mouse-enter on-mouse-enter
    :on-key-down (fn [^js e]
                   (when (contains? #{"Enter" "Space"} (.-code e))
                     (.preventDefault e)
                     ((:on-change input))))}
   [:label
    {:data-testid (get input :data-testid (str "item-radio-" label))}
    [:div.flex.items-center.duration-300.active:duration-0.cursor-pointer.select-none.active:bg-black.active:bg-opacity-10.rounded-md
     [:div.cursor-pointer.inline-block.align-middle.relative
      [:input.hidden (merge {:type "checkbox"} (dissoc input :data-testid))]]
     (if label-view
       [:div.w-full
        [label-view button]]
       [:div.px-3.py-2
        {:class (when (:disabled input) ["opacity-50"])}
        [:div.flex.items-center.gap-3
         {:class (when (:checked input) ["font-bold" "text-indigo-600"])}
         (if (:checked input)
           [:i.shrink-0.flex.items-center.justify-center.text-white.dark:text-black.rounded-full.border
            {:class (str "w-[22px] h-[22px] " bg-primary border-primary)}
            [:div.rounded-full.bg-white.relative {:style {:width 9 :height 9 :top 0 :left 0}}]]
           [:i.shrink-0.flex.items-center.justify-center.text-white.dark:text-black.rounded-full.border.border-black.border-opacity-30.dark:border-white.dark:border-opacity-30
            {:class ["w-[22px]" "h-[22px]"]}])
         [:div
          label
          (when description
            [:div.text-slate-700
             {:class ["text-[0.725rem]"]
              :data-testid (str (:data-testid input) "=description")}
             description])
          (when error
            [:div.text-red-600
             {:class ["text-[0.725rem]"]
              :data-testid (str (:data-testid input) "=error")}
             error])]]])]]])

(declare table)

(defscene radios
  [table
   {:separated? false
    :title "Fahrzeug auswählen…"
    :items [[radio-button {:label "kein Fahrzeug"
                           :input {:value :no-vehicle
                                   :name :vehicle
                                   :checked true}}]
            [radio-button {:label "BMW X2"
                           :description "DUCT4LE6886071527"
                           :error "blockiert"
                           :input {:value :bmw-x2
                                   :name :vehicle
                                   :disabled true}}]]}])

(defn list-item-radio [{:keys [input label error inline? variant description class on-mouse-enter style]}]
  (let [variant (or variant :center)]
    [:li.bg-white
     {:on-mouse-enter on-mouse-enter
      :style style}
     [:label
      [:div.flex.items-center.active:duration-0.cursor-pointer.select-none.active:bg-black.active:bg-opacity-10
       {:class (concat (if inline? ["pl-8" "pr-4"] ["pl-4"])
                       (when (= :center variant) ["items-center"])
                       class)}
       [:div.mr-4.shrink-0.py-2
        {:class (when (:disabled input) "opacity-50 pointer-events-none")}
        [:div.cursor-pointer.inline-block.align-middle.relative
         [:input.hidden (merge {:type "checkbox"} (dissoc input :data-testid))]
         (if (:checked input)
           [:i.flex.items-center.justify-center.text-white.dark:text-black.rounded-full.border
            {:data-testid (get input :data-testid (str "item-radio-" label))
             :class (str "w-[22px] h-[22px] " bg-primary border-primary)}
            [:div.rounded-full.bg-white.relative {:style {:width 9 :height 9 :top 0 :left 0}}]]
           [:i.flex.items-center.justify-center.text-white.dark:text-black.rounded-full.border.border-black.border-opacity-30.dark:border-white.dark:border-opacity-30
            {:data-testid (get input :data-testid (str "item-radio-" label))
             :class "w-[22px] h-[22px] "}])]]
       [:div.pr-4.w-full.relative.py-2.5.flex.flex-col.justify-center
        {:class (str "min-h-[44px] " (when-not inline? hairline-b))}
        [:div.flex.justify-between.items-center
         [:div.shrink (when (:disabled input)
                        {:class "opacity-50"})
          label]]

        (when description
          [:div.text-slate-700
           {:class "text-[0.725rem]" :data-testid (str (:data-testid input) "=description")}
           description])
        (when error
          [:div.text-red-600
           {:class "text-[0.725rem]" :data-testid (str (:data-testid input) "=error")}
           error])]]]]))

(defn table [{:as opts
              :keys [title subtitle items class inset? data-testid gap separated? footer]
              :ui/keys [margin-bottom]
              :or {separated? true}}]
  [:div {:class (ui/class-vec (case margin-bottom
                                :xs "mb-1"
                                :sm "mb-3"
                                :md "mb-5"
                                :lg "mb-8"
                                :none "mb-0"
                                "mb-8")
                              class)}
   (when title
     [:div.mt-8.-mb-6.font-semibold.text-sm
      {:class (str (when-not subtitle "flex justify-between items-center ")
                   (if inset? "px-6 " "px-4 "))}
      title
      (when subtitle
        [:div.text-xs.mt-1.text-gray-500.font-normal subtitle])])
   [:div.mt-8.relative.z-10
    {:class (if inset? "rounded-lg mx-3 overflow-hidden " (when separated? hairline-t))}
    (into [:ul.last-child-hairline-b-none.flex.flex-col
           (cond-> {:class [(when gap (str "gap-" gap))]}
             data-testid (assoc :data-testid data-testid))]
          items)]
   (when footer
     [:div.text-xs {:class ["mt-1" (if inset? "px-6 " "px-4 ")]}
      footer])])

(defn table-section-header [& content]
  (into [:div.px-3.py-1.bg-slate-100.border-b.border-slate-200.text-xs.font-bold]
        content))

(defn content-block [& content]
  (let [history? (useContext ui/history-context)]
    (into [:div.z-10.relative.pl-4.pr-4.my-8.flex.flex-col]
          content)))

(defn inline-prompt [& content]
  (let [icon (first content)
        icon? (keyword? icon)]
    [content-block
     (when icon? [:div.opacity-50.flex.justify-center.mb-1 [ui/icon {:size 40} icon]])
     (into [:div.text-center.opacity-60] (if icon? (rest content) content))]))

(defn button-outline [& content]
  (let [attrs (first content)
        attrs? (map? attrs)]
    (into
     [:button
      (merge
       {:class (str
                "uppercase flex text-center justify-center items-center appearance-none px-2 py-1 transition-colors focus:outline-none enabled:cursor-pointer select-none overflow-hidden z-10 w-full flex relative duration-100 font-semibold rounded border-2 active:bg-opacity-15 h-11 "
                border-primary bg-primary-active text-primary
                (when (:disabled attrs) "opacity-50 cursor-disabled "))}
       (when attrs? attrs))]
     (if attrs? (rest content)
         content))))

(defn button-full [& content]
  (let [attrs (first content)
        attrs? (map? attrs)]
    (into
     [:button
      (ui/with-events
        (merge {:tab-index 0
                :class (str
                        "uppercase flex text-center justify-center items-center appearance-none px-2 py-1 transition-colors focus:outline-none focus-visible:ring-2 ring-offset-4 focus-visible:ring-indigo-600 enabled:cursor-pointer select-none overflow-hidden z-10 w-full flex relative duration-100 font-semibold rounded text-white h-11 "
                        (case (:variant attrs)
                          :destructive (str bg-destructive bg-destructive bg-destructive-hover)
                          (str bg-primary bg-primary-active bg-primary-hover))
                        (when (or (:loading attrs) (:disabled attrs)) "opacity-50 cursor-not-allowed "))}
               (when attrs? (let [{:keys [type on-click]} attrs]
                              (cond-> attrs
                                (:loading attrs) (assoc :disabled true)
                                true (dissoc :loading)
                                true (assoc :type (cond type type
                                                        on-click :button
                                                        :else :submit)))))))]
     (if attrs?
       (if (:loading attrs) (str (tr "Loading") "…") (rest content))
       content))))

(defn segment [{:keys [label on-click active?]}]
  [:button {:class (str "flex-shrink-0 flex items-center appearance-none py-1 transition-colors focus:outline-none cursor-pointer duration-100 font-semibold px-4 rounded-full text-sm h-7 "
                        (when active? "bg-white shadow"))
            :on-click on-click}
   label])

(defn segmented-control [& content]
  [:div.flex.mx-3
   (into [:div {:class "flex justify-center items-center overflow-hidden rounded-full p-0.5 space-x-1 relative bg-black bg-opacity-5"}]
         content)])

(defscene components
  :params (atom {:checkbox-stepper 0})
  [!state]
  [:div
   [scroll-content
    [navbar {:title "Navbar"
             :subtitle "Subtitle"
             :back [back-link {:title "Back" :route nil}]
             :right {:title "Right" :route nil}}]
    [inline-prompt :info "Here’s a list of all supported components, starting with this inline prompt."]
    [table {:title "List"
            :items [[list-item {:title "Fahrzeugeingang"}]
                    [list-item {:title "Dienstleistungen & Handling"}]
                    [list-item {:title "Fahrzeugausgang"}]]}]

    [table {:title "Stepper"
            :items [[:div
                     [:div.flex
                      [:button.flex.items-center.rounded-l-full.text-white.px-3.py-1.cursor-pointer.bg-indigo-600.enabled:hover:bg-indigo-700.enabled:active:bg-indigo-600


                       [ui/icon {:size 14} :minus]]
                      [:div.flex.items-center.justify-center.bg-white.text-indigo-600.px-5.py-1.border-t-2.border-b-2.border-indigo-700.font-semibold

                       "0"]
                      [:button.flex.items-center.rounded-r-full.text-white.px-3.py-1.enabled:cursor-pointer.bg-indigo-600.enabled:hover:bg-indigo-700.enabled:active:bg-indigo-600

                       [ui/icon {:size 14} :plus]]]]]}]

    [table {:title "Segmented control"
            :items [[:div.py-5.m-auto
                     [segmented-control
                      [segment {:label "Gasoline"}]
                      [segment {:label "Diesel"}]
                      [segment {:label "Electric" :active? true}]]]]}]

    [table {:title "Checkboxes"
            :items [[list-item-checkbox {:label "Checked"
                                         :input {:checked true
                                                 :name nil}}]
                    [list-item-checkbox-stepper {:label "Kennzeichen"
                                                 :input {:value (:checkbox-stepper @!state)
                                                         :min 0
                                                         :max 3
                                                         :on-change #(swap! !state assoc :checkbox-stepper %)}}]
                    [list-item-checkbox-stepper {:label "Kennzeichen"
                                                 :input {:value (:checkbox-stepper @!state)
                                                         :min 0
                                                         :max 3
                                                         :on-change #(swap! !state assoc :checkbox-stepper %)}}]
                    [list-item-checkbox {:label "Unchecked"
                                         :input {:checked false
                                                 :name nil}}]
                    [list-item-checkbox {:label "Unchecked"
                                         :input {:checked false
                                                 :name nil}}]]}]
    [table {:title "List with icons and arrows"
            :items [[list-item-disclose {:title "Fahrzeugeingang"
                                         :icon [framed-icon "bg-orange-600" :log-in]
                                         :route nil}]
                    [list-item-disclose {:title "Dienstleistungen & Handling"
                                         :icon [framed-icon :check-square]
                                         :route nil}]
                    [list-item-disclose {:title "Fahrzeugausgang"
                                         :icon [framed-icon "bg-green-600" :log-out]
                                         :route nil}]]}]
    [table {:inset? true
            :title "Inset List"
            :items [[list-item {:title "Fahrzeugeingang"}]
                    [list-item {:title "Dienstleistungen & Handling"}]
                    [list-item {:title "Fahrzeugausgang"}]]}]
    [table {:title "Text Inputs"
            :items [[list-item-input {:label "Your Name"
                                      :input {:placeholder "Enter your name…"
                                              :name nil}}]]}]

    [table {:title "Text Inputs"
            :items [[list-item-input {:error "Enter valid name"
                                      :label "Your Name"
                                      :input {:placeholder "Enter your name…"
                                              :name nil}}]]}]

    [table {:title "Text Inputs"
            :items [[list-item-input {:label "Your Name"
                                      :input {:placeholder "Enter your name…"
                                              :disabled? true
                                              :name nil}}]]}]

    [table {:title "Text Inputs (Masked + Unit)"
            :items [[list-item-input {:input {:mask :ui.mask/mileage
                                              :value (:mileage @!state)
                                              :right "km"
                                              :on-change #(swap! !state assoc :mileage (.. % -target -value))}}]]}]
    [table {:title "Radios"
            :items [[list-item-radio {:label "Radio 1"
                                      :input {:checked true
                                              :name "radio"}}]
                    [list-item-radio {:label "Radio 2"
                                      :input {:checked false
                                              :name "radio"}}]]}]

    [table {:title "Checkbox Stepper"
            :items [[list-item-checkbox-stepper {:label "Kennzeichen"
                                                 :input {:value (:checkbox-stepper @!state)
                                                         :on-change #(swap! !state assoc :checkbox-stepper %)}}]]}]

    [toolbar
     [button-full {} "A button"]]]])

(def icon-task-complete
  [ui/icon-socket {:variant :green} [ui/icon :check]])

;; TODO: Refactor to use [ui/icon] so that we can select color
(def icon-task-complete-warning
  [:div.rounded-full.w-6.h-6.bg-orange-600.flex.items-center.justify-center.text-white
   [ui/icon {:size 16} :check]])

(def icon-task-fail
  [:div.rounded-full.w-6.h-6.bg-red-600.flex.items-center.justify-center.text-white
   [ui/icon {:size 16} :x]])

(def icon-service-complete
  [:div.w-6.h-6.flex.items-center.justify-center.text-gray-400
   [ui/icon {:size 20} :check]])

(defn icon-color [color]
  [:div.w-10.h-6.flex.items-center.justify-center.rounded-md
   {:style {:background-color color
            :border "1px solid rgba(0,0,0,.1)"
            :box-shadow "inset 0 1px 1px rgba(255,255,255,.2), 0 2px 3px rgba(0,0,0,.2)"}}])

(def icon-incomplete
  [:div.w-6.h-6])

(def icon-scan
  [:div.rounded-full.w-6.h-6.bg-slate-400.flex.items-center.justify-center.text-white
   [ui/icon {:size 16} :scan]])

(def icon-truck
  [:div.rounded-full.w-6.h-6.bg-slate-400.flex.items-center.justify-center.text-white
   [ui/icon {:size 16} :truck]])

(def icon-ship
  [:div.rounded-full.w-6.h-6.bg-slate-400.flex.items-center.justify-center.text-white
   [ui/icon {:size 16} :ship]])

(def icon-parking
  [:div.rounded-full.w-6.h-6.bg-sky-500.flex.items-center.justify-center.text-white
   [ui/icon {:size 24} :parking]])

(defn info-bar [fahrzeug]
  [:div.justify-center.opacity-60.flex.items-center.p-1.gap-2
   {:class (str "relative text-[11px] " bg-bars translucent hairline-b)}
   #_[:div.flex.items-center.mr-2.truncate
      [ui/icon {:size 10} :map-pin]
      [:span.ml-1 "Vorlauf FZ-Werkstatt"]]
   (str/join " / " (remove nil? [(get fahrzeug :vehicle/vin) (get fahrzeug :vehicle/model)]))])

(defn time-picker [{:keys [^js value on-change class data-testid]}]
  (let [time-value (when value (str (.padStart (str (.getHours value)) 2 "0") ":"
                                    (.padStart (str (.getMinutes value)) 2 "0")))
        on-change-time (fn [e]
                         (let [[hh mm] (str/split (.. e -target -value) #":")]
                           (on-change
                            (doto (js/Date. (.getTime (or value (ui/now))))
                              (.setHours (parse-long hh))
                              (.setMinutes (parse-long mm))
                              (.setSeconds 0)
                              (.setMilliseconds 0)))))]
    [:div.flex.items-center
     {:style {:max-width 80}}
     [:input.bg-transparent.outline-none.text-left.text-base.m-0.p-0.flex-auto
      {:type :time
       :value time-value
       :on-change on-change-time
       :class class
       :data-testid (when data-testid (str data-testid "-time"))}]]))

(defn format-weekday-short [^js date]
  (.format (js/Intl.DateTimeFormat
            (locale/get-current-iso-locale)
            #js {:weekday "short"}) date))

(defn date-picker [{:keys [^js value on-change date days-before days-after class data-testid]}]
  (let [!ref (hooks/use-ref)
        date (or date (ui/now))
        on-change-date (fn [e]
                         (if (str/blank? (.. e -target -value)) (on-change nil)
                             (let [selected (js/Date. (js/Date.parse (.. e -target -value)))
                                   date' (doto (js/Date. (.getTime (or value (ui/now))))
                                           (.setFullYear (.getFullYear selected))
                                           (.setMonth (.getMonth selected))
                                           (.setDate (.getDate selected)))]
                               (on-change date'))))
        [min-d max-d] [(when days-before (ui/add-days date (- days-before)))
                       (when days-after (ui/add-days date days-after))]]
    [:div.flex.gap-1.text-base.flex.items-center
     {:on-click #(.focus @!ref)
      :style {:max-width 205}}
     (when (and value (time/today? value)) [:span (tr "Today") ", "])
     (when value [:span (format-weekday-short value) "."])
     [:input.bg-transparent.outline-none.text-left.text-base.m-0.p-0.flex-auto
      {:type :date
       :ref !ref
       :min min-d
       :max max-d
       :on-change on-change-date
       :value (if value (ui/format-date value) "")
       :data-testid (when data-testid (str data-testid "-date"))}]]))

(defn datetime-picker [{:as opts :keys [^js value on-change]}]
  [:div.bg-white
   [:div.border-b.pb-2.mb-2.-mr-4
    [date-picker opts]]
   [time-picker opts]])

(defn signature [{:keys [label on-signature data-testid from-image]}]
  (let [!canvas-container (hooks/use-ref nil)
        !undo-button (hooks/use-ref nil)]
    (hooks/use-effect
     (fn []
       (when-let [el @!canvas-container]
         (let [canvas (.querySelector el "canvas")
               resize! #(set! (.. canvas -width) (.-offsetWidth @!canvas-container))]
           (js/addEventListener "resize" resize!)
           (resize!)
           (let [pad (signature-pad. canvas)
                 undo! (fn []
                         (when-let [^js data (.toData pad)]
                           (.pop data)
                           (.fromData pad data)))]
             #_(when from-image
                 (.fromDataURL pad from-image))
             (.addEventListener pad "afterUpdateStroke" #(on-signature (.toDataURL pad)))
             (.addEventListener @!undo-button "pointerdown" undo!)
             (fn []
               (js/removeEventListener "resize" resize!))))))
     [@!canvas-container])
    [:div.w-full.rounded.border.border-slate-300.shadow-inner.relative
     {:ref !canvas-container}
     [:canvas {:height 100 :data-testid data-testid}]
     [:div.absolute.border-t.border-slate-300.border-dashed.left-0.right-0.pointer-events-none {:class "bottom-[24px]"}]
     [:div.text-xs.py-1.px-2.flex.items-center
      {:style {:height 24}}
      [:div.flex.items-center.gap-1
       [:div.text-base "✍️"]
       [:div.font-bold (or label (tr "Please sign here"))]]]
     [:div.absolute.bottom-0.flex.items-center.justify-center
      {:class ["w-[24px]" "h-[24px]" "right-[0]"]
       :ref !undo-button}
      [ui/icon {:size 12} :rotate-ccw]]]))

(defn sign-here [props]
  [:div.bg-white.rounded-lg
   [signature props]])

(defn fail [error]
  [:div.flex.justify-center
   [:div.bg-red-100.p-3.text-sm.text-red-600.border-2.border-red-600.rounded-lg.text-center
    [:span.font-bold (tr "There was an error with this view:")]
    [:br]
    [:div.font-mono (str error)]]])

(defn layout [& content]
  (let [[{:as props :keys [component]} content] (ui/opts+content content)]
    [:<>
     [:style ".mobile-scroll-content-legacy { padding-bottom: 0 !important; }"] ; TODO remove when ui/mobile-layout no longer wraps view in mobile/scroll-content
     (into [(or component :div)
            (-> props
                (dissoc :component)
                (assoc :class "w-full max-h-full flex flex-col")
                (assoc :style (if (http/speculative-transactions?)
                                {:height "calc(100% - 22px)"}
                                {:height "100%"})))]
           content)]))


(defn content [& content]
  (let [!ref (hooks/use-ref)]
    (hooks/use-effect
     (fn [] (when (seq @(deframe/!route-get :ductile.ui.view-stack/view-stack))
              (.scrollTo ^js @!ref 0 0)))
     [@(deframe/!route-get :ductile.ui.view-stack/view-stack)])
    (into [:div.flex-auto.overflow-auto.overscroll-contain
           {:class bg-page
            :ref !ref}]
          content)))

(defn footer [& content]
  [:div.w-full.relative
   [:div.absolute.w-full.h-full.left-0.top-0
    {:class (str hairline-t bg-bars translucent)}]
   (into [:div.flex.justify-between.items-center.w-full.px-2.py-2.relative]
         content)])

(defscene mobile-layout-no-content
  [layout
   [navbar {:title "Navbar"
            :subtitle "Subtitle"
            :back {:title "Back"}
            :right {:title "Right" :route nil}}]
   [content "content"
    [button-full {} "A button"]]
   [footer [button-full {} "Confirm"]]])

(defscene mobile-layout
  [layout
   [navbar {:title "Navbar"
            :subtitle "Subtitle"
            :back {:title "Back"}
            :right {:title "Right" :route nil}}]
   [content (repeat 1000 "content ")]
   [footer [button-full {} "Confirm"]]])
